// import React, { useState, useEffect } from 'react';
// import { NotificationForPatient, NotificationForDoctor } from '../services/notification';
// import useNotificationStore from '../../zustand/notification';
// const NotificationsDropdown = ({ user }) => {
//     console.log("hello 1")
//     const { decrementCount } = useNotificationStore();
//     const [currentPage, setCurrentPage] = useState(1);
//     const [allNotifications, setNotifications] = useState([]);
//     const [notificationCount, setNotificationCount] = useState(0);
//     const [loading, setLoading] = useState(false);

//     const limit = 4;
//     const totalPages = Math.ceil(notificationCount / limit);
//     useEffect(() => {
//          const fetchNotifications = async (page = 1) => {
//              setLoading(true);

//              try {
//                  let res;

//                  if (Number(user?.usertype) === 1) {
//                      res = await NotificationForPatient.patientNotificationList(page, limit);
//                  } else if (Number(user?.usertype) === 2) {
//                      res = await NotificationForDoctor.doctorNotificationList(page, limit);
//                  }

//                  if (res?.data) {
//                      setNotifications(res.data.data);
//                      setNotificationCount(res.data.total);
//                  }
//                  setTimeout(() => {
//                      setNotifications([]);
//                  }, 1000);
//              } catch (error) {
//                  console.error('Error fetching notifications:', error?.message);
//              } finally {
//                  setLoading(false);
//              }
//          };
//             fetchNotifications(currentPage);
//      },  [ user, currentPage]);
    

//     const handleNotificationClick = async (id) => {
//         try {
//             if (user?.usertype === 1) {
//                 await NotificationForPatient.isReadNotificationPatient(id);
//             } else if (user?.usertype === 2) {
//                 await NotificationForDoctor.isReadNotificationDoctor(id);
//             }
//             decrementCount();
//             // fetchNotifications(currentPage);
//         } catch (error) {
//             console.error('Error marking notification as read:', error);
//         }
//     };

//     const handlePageChange = (newPage) => {
//         if (newPage >= 1 && newPage <= totalPages) {
//             setCurrentPage(newPage);
//         }
//     };

//     // useEffect(() => {
//     //     if (user?.usertype) {
           
//     //             fetchNotifications(currentPage);
            
//     //     }
//     // }, [user, currentPage]);

//     return (
//         <div className="p-6 rounded border border-gray-300 bg-white items-center">
//             <h2 className="text-lg font-bold  text-center">Notifications</h2>

//             <div className="w-full relative min-h-[200px]">
//                 {allNotifications.length === 0 && !loading ? (
//                     <div className="py-8 text-gray-500 text-center">No notifications found.</div>
//                 ) : (
//                     allNotifications.map((n) => (
//                         <div
//                             key={n.id}
//                             className={`py-4 px-5 border-b cursor-pointer hover:bg-gray-100 ${
//                                 n.isRead ? 'text-gray-500' : 'font-semibold'
//                             }`}
//                             onClick={() => handleNotificationClick(n.id)}
//                         >
//                             <div>{n.title}</div>
//                             <div className="text-base text-gray-600">{n.content}</div>
//                         </div>
//                     ))
//                 )}

//                 {/* Loader overlay */}
//                 {loading && (
//                     <div className="absolute inset-0 bg-white bg-opacity-60 flex justify-center items-center z-10">
//                         <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-blue-500 border-solid"></div>
//                     </div>
//                 )}
//             </div>

//             {notificationCount > 0 && (
//                 <div className="flex justify-center items-center mt-4 w-full">
//                     <button
//                         onClick={() => handlePageChange(currentPage - 1)}
//                         disabled={currentPage === 1}
//                         className={`mx-2 px-3 py-1 rounded ${
//                             currentPage === 1 ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'
//                         }`}
//                     >
//                         Prev
//                     </button>
//                     <span className="text-sm text-gray-700">
//                         Page {currentPage} of {totalPages}
//                     </span>
//                     <button
//                         onClick={() => handlePageChange(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                         className={`mx-2 px-3 py-1 rounded ${
//                             currentPage === totalPages ? 'text-gray-400 cursor-not-allowed' : 'text-blue-500'
//                         }`}
//                     >
//                         Next
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default NotificationsDropdown;


import React, { useState, useEffect, useRef } from 'react';
import { NotificationForPatient, NotificationForDoctor } from '../services/notification';
import { useDispatch } from 'react-redux';
import { decrementCount } from '../../redux/slices/notificationSlice';

const NotificationsDropdown = ({ user }) => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [allNotifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const isMounted = useRef(false); 

    const limit = 4;
    const totalPages = Math.ceil(notificationCount / limit);

    useEffect(() => {
 
        if (!isMounted.current) {
            isMounted.current = true;
            return; 
        }

        const fetchNotifications = async (page = 1) => {
            if (!user) return;

            setLoading(true);
            try {
                let res;

                if (Number(user?.usertype) === 1) {
                    res = await NotificationForPatient.patientNotificationList(page, limit);
                } else if (Number(user?.usertype) === 2) {
                    res = await NotificationForDoctor.doctorNotificationList(page, limit);
                }

                if (res?.data) {
                    setNotifications(res.data.data || []);
                    setNotificationCount(res.data.total || 0);
                }
            } catch (error) {
                console.error('Error fetching notifications:', error);
                setNotifications([]);
            } finally {
                setLoading(false);
            }
        };

        fetchNotifications(currentPage);

        return () => {
        };
    }, [user, currentPage]);

    const handleNotificationClick = async (id) => {
        try {
            if (Number(user?.usertype) === 1) {
                await NotificationForPatient.isReadNotificationPatient(id);
            } else if (Number(user?.usertype) === 2) {
                await NotificationForDoctor.isReadNotificationDoctor(id);
            }
            dispatch(decrementCount());

            const fetchNotifications = async (page = currentPage) => {
                if (!user) return;
                setLoading(true);
                try {
                    let res;
                    if (Number(user?.usertype) === 1) {
                        res = await NotificationForPatient.patientNotificationList(page, limit);
                    } else if (Number(user?.usertype) === 2) {
                        res = await NotificationForDoctor.doctorNotificationList(page, limit);
                    }
                    if (res?.data) {
                        setNotifications(res.data.data || []);
                        setNotificationCount(res.data.total || 0);
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            };
            fetchNotifications();
        } catch (error) {
            console.error('Error marking notification as read:', error);
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages && newPage !== currentPage) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div className="p-6 rounded border border-gray-300 bg-white">
            <h2 className="text-lg font-bold text-center mb-4">Notificaciones</h2>

            <div className="w-full relative min-h-[200px]">
                {allNotifications.length === 0 && !loading ? (
                    <div className="py-8 text-gray-500 text-center">No hay notificaciones.</div>
                ) : (
                    allNotifications.map((n) => (
                        <div
                            key={n.id}
                            className={`py-4 px-5 border-b cursor-pointer hover:bg-gray-100 transition ${
                                n.isRead ? 'text-gray-500' : 'font-semibold text-gray-900'
                            }`}
                            onClick={() => handleNotificationClick(n.id)}
                        >
                            <div className="font-medium">{n.title}</div>
                            <div className="text-sm text-gray-600 mt-1">{n.content}</div>
                            <div className="text-xs text-gray-400 mt-2">
                                {new Date(n.createdAt).toLocaleDateString('es-ES', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </div>
                        </div>
                    ))
                )}

                {loading && (
                    <div className="absolute inset-0 bg-white bg-opacity-70 flex justify-center items-center z-10 rounded">
                        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-blue-600"></div>
                    </div>
                )}
            </div>

            {totalPages > 1 && (
                <div className="flex justify-center items-center mt-6 gap-4">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1 || loading}
                        className={`px-4 py-2 rounded ${
                            currentPage === 1 || loading
                                ? 'text-gray-400 cursor-not-allowed'
                                : 'text-blue-600 hover:bg-blue-50'
                        }`}
                    >
                        Anterior
                    </button>
                    <span className="text-sm text-gray-700">
                        Página {currentPage} de {totalPages}
                    </span>
                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages || loading}
                        className={`px-4 py-2 rounded ${
                            currentPage === totalPages || loading
                                ? 'text-gray-400 cursor-not-allowed'
                                : 'text-blue-600 hover:bg-blue-50'
                        }`}
                    >
                        Siguiente
                    </button>
                </div>
            )}
        </div>
    );
};

export default NotificationsDropdown;